import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';
import type ChangeOwnPasswordProperties from './ChangeOwnPassword.properties.ts';
import ChangeOwnPasswordDesktopView from './desktop/ChangeOwnPassword.desktop.view.tsx';
import ChangeOwnPasswordMobileView from './mobile/ChangeOwnPassword.mobile.view.tsx';

export default function ChangeOwnPasswordView(props: ChangeOwnPasswordProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isDesktop && <ChangeOwnPasswordDesktopView {...props} />}
      {isMobile && <ChangeOwnPasswordMobileView {...props} />}
    </>
  );
}
